<template>
  <v-container class="ma-0 pa-0" fluid>
    <v-btn
      outlined
      @click="getAllCustomersInCurrentPackage"
      :loading="loading"
      width="150"
      class="mt-1 text-capitalize"
      color="primary"
    >
      <v-icon class="me-1">mdi-export</v-icon>Export
    </v-btn>
    <div v-show="false">

      <v-data-table
      id="printPackageReview"
      :mobile-breakpoint="0"
      :headers="headers"
      :items-per-page="count"
      hide-default-footer
      :items="customers"
      class="elevation-1 mt-5 mx-4"
      :loading="loading"
    >
      <template v-slot:item.customerId="{ item }">
        {{ item.customerId }}
      </template>
      <template v-slot:item.name="{ item }">
        <router-link
          v-if="item.user"
          :to="{
            name: 'CustomerDetails',
            params: { customerId: item._id },
            query: { customerId: item._id }
          }"
          class="mx-auto"
        >
          {{
            item.user.firstnameEn[0].toUpperCase() +
              item.user.firstnameEn.substring(1)
          }}
          {{
            item.user.lastnameEn[0].toUpperCase() +
              item.user.lastnameEn.substring(1)
          }}
        </router-link>
        <!-- </v-row> -->
      </template>
    </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { Utils } from "../../utils/utils";
// import moment from "moment";
export default {
  components: {},

  props: {
    packageId:{
      required:true
    },
    headers: {
      required: true,
    },
    dateRange:{
      required:true
    }
  },
  data(){
   return {
    customers:[],
    loading:false,
    count:0
   }
  },
  methods: {
    getAllCustomersInCurrentPackage() {
      this.loading = true;
      if (!this.packageId) {
        return false;
      }
      this.$apollo
        .query({
          query: require("@/menu-packages/api/getAllCustomersInCurrentPackage.graphql"),
          variables: {
            input: {limit:0,skip:0},
            packageId: this.packageId,
            fromDate: this.dateRange.fDate,
            toDate: this.dateRange.tDate
          }
        })
        .then(data => {
          this.loading = false;
          if (data.data) {
            this.customers = data.data.getAllCustomersInCurrentPackage.customers;
            this.count = data.data.getAllCustomersInCurrentPackage.count
            setTimeout(
              ()=>{
                Utils.htmlToExcel("printPackageReview", "PackageReview", false);
              },
              1000
            )
          }
        });
    }
  },
};
</script>